import React, { useMemo } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const ResolucaoPieChart = ({
  totalRecebimento = 0,
  totalAcordos = 0,
  totalPenaltis = 0,
}) => {
  const dataPie = {
    labels: [
      'Recebimento (à vista)',
      'Acordo (renegociação)',
      'Sem Resolução (Rescisão/Transf. p/ Jurídico/Inadim.)',
    ],
    datasets: [
      {
        data: [totalRecebimento, totalAcordos, totalPenaltis],
        backgroundColor: [
          'rgba(54, 162, 235, 0.7)',
          'rgba(255, 206, 86, 0.7)',
          'rgba(255, 99, 132, 0.7)',
        ],
        borderColor: [
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(255, 99, 132, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const optionsPie = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      tooltip: {
        callbacks: {
          label: context => {
            const label = context.label || '';
            const value = context.parsed || 0;
            const somaTotal = totalRecebimento + totalAcordos + totalPenaltis;
            const perc =
              somaTotal > 0
                ? ((value / somaTotal) * 100).toFixed(2) + '%'
                : '0%';
            return `${label}: ${value.toLocaleString('pt-BR')} (${perc})`;
          },
        },
      },
    },
  };

  return (
    <div style={{ width: '65%' }}>
      <h5 style={{ textAlign: 'center', marginBottom: '1rem' }}>
        Percentual de Resolução
      </h5>
      <Pie data={dataPie} options={optionsPie} />
    </div>
  );
};

export default ResolucaoPieChart;
